// extracted by mini-css-extract-plugin
export var styles = "breadcrumbs-module--styles--1VOuV";
export var zzz = "breadcrumbs-module--zzz--2mogG";